import React, { useState, useEffect, useRef } from 'react';
import { loginWithLabV } from '../api';

export default function LoginModal({ open, onSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const usernameRef = useRef(null);

  useEffect(() => {
    if (open) {
      setError('');
      setTimeout(() => usernameRef.current?.focus(), 50);
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setError('');
    setLoading(true);
    try {
      await loginWithLabV(username.trim(), password);
      onSuccess();
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-overlay">
      <div className="login-modal" role="dialog" aria-modal="true" aria-label="Sign in">
        <div className="login-modal-header">
          <img src="/logo.svg" alt="LabV" className="login-modal-logo" />
          <h2 className="login-modal-title">Sign in to LabV</h2>
          <p className="login-modal-subtitle">Enter your LabV credentials to continue</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit} noValidate>
          <label className="login-label" htmlFor="login-username">Email</label>
          <input
            id="login-username"
            ref={usernameRef}
            className="login-input"
            type="email"
            autoComplete="username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            disabled={loading}
            placeholder="you@example.com"
            required
          />

          <label className="login-label" htmlFor="login-password">Password</label>
          <input
            id="login-password"
            className="login-input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
            placeholder="••••••••"
            required
          />

          {error && <p className="login-error">{error}</p>}

          <button
            type="submit"
            className="login-submit"
            disabled={loading || !username.trim() || !password}
          >
            {loading ? <span className="login-spinner" /> : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
